import { render } from "./scanCodeOrderModel.vue?vue&type=template&id=fb50276c"
import script from "./scanCodeOrderModel.vue?vue&type=script&lang=js"
export * from "./scanCodeOrderModel.vue?vue&type=script&lang=js"

import "./scanCodeOrderModel.vue?vue&type=style&index=0&id=fb50276c&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__